import { EntityLabel, KPI, KPIGroup } from '@esg/esg-global-types';
import { apollo_client } from '../app/db_util';
import { MetadataError } from '@ep/error-handling';
import { GET_KPIS_QUERY } from '../graphql/queries/kpi';
import { generateUuidV4 } from '../../util/uuid';

export interface KPIExtended extends KPI {
  kpi_group: KPIGroup;
}

// Singular and plural label for model entity.
export const kpi_label: EntityLabel = {
  one: 'KPI',
  many: 'KPIs'
};

/**
 * Query all KPIs for Questionnaire.
 * @param {string} questionnaire_id Questionnaire containing KPIs.
 * @param {string} id query a specific KPI by id.
 * @returns {Promise<Array<KPIExtended>>}
 */
export const getKPIs = async (
  questionnaire_id: string,
  id?: string
): Promise<Array<KPIExtended>> => {
  try {
    const kpis: Array<KPIExtended> = await apollo_client
      .query({
        variables: {
          questionnaire_id: questionnaire_id,
          id: id
        },
        query: GET_KPIS_QUERY,
        fetchPolicy: 'no-cache'
      })
      .then((response) => {
        return response.data.kpis;
      });
    return kpis;
  } catch (err: unknown) {
    const tracking_id: string = generateUuidV4();
    throw new MetadataError(
      err instanceof Error ? err.message : 'Error: getKPIs failed on an unknown error.',
      {
        questionnaire_id: questionnaire_id,
        id: id
      },
      tracking_id
    );
  }
};
